(() => {
  const STORAGE_KEY = 'dekora_mx_recent_searches';
  const MAX_ITEMS = 5;

  /**
   * Limpia espacios y normaliza el término.
   */
  function normalizeTerm(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * Obtiene las búsquedas guardadas.
   */
  function getRecentSearches() {
    try {
      const storedValue = localStorage.getItem(STORAGE_KEY);
      const searches = storedValue ? JSON.parse(storedValue) : [];

      return Array.isArray(searches) ? searches : [];
    } catch (error) {
      console.error('No se pudieron leer las búsquedas recientes:', error);
      return [];
    }
  }

  /**
   * Guarda una búsqueda sin repetirla.
   */
  function saveRecentSearch(value) {
    const term = normalizeTerm(value);

    if (!term || term === '*') {
      return;
    }

    try {
      const normalizedTerm = term.toLocaleLowerCase('es-MX');

      const searches = getRecentSearches().filter((savedTerm) => {
        return (
          normalizeTerm(savedTerm).toLocaleLowerCase('es-MX') !==
          normalizedTerm
        );
      });

      searches.unshift(term);

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(searches.slice(0, MAX_ITEMS))
      );
    } catch (error) {
      console.error('No se pudo guardar la búsqueda reciente:', error);
    }
  }

  /**
   * Crea el enlace de una búsqueda reciente.
   */
  function createSearchLink(term, container) {
    const link = document.createElement('a');
    const searchUrl = container.dataset.searchUrl || '/search';
    const url = new URL(searchUrl, window.location.origin);

    url.searchParams.set('q', term);
    url.searchParams.set('options[prefix]', 'last');

    link.href = `${url.pathname}${url.search}`;

    link.className =
      'tw-flex lg:tw-items-center tw-gap-2 lg:tw-gap-4 ' +
      'tw-p-2 lg:tw-p-4 xl:hover:tw-bg-secondary-soft ' +
      'tw-rounded active:tw-bg-secondary';

    const iconUrl = container.dataset.refreshIcon;

    if (iconUrl) {
      const icon = document.createElement('img');

      icon.src = iconUrl;
      icon.alt = '';
      icon.width = 16;
      icon.height = 16;
      icon.setAttribute('aria-hidden', 'true');

      icon.className =
        'tw-w-4 tw-h-4 tw-mt-1 lg:tw-mt-0';

      link.appendChild(icon);
    }

    const label = document.createElement('span');

    label.className = 'tw-text-lg tw-text-left';
    label.textContent = term;

    link.appendChild(label);

    return link;
  }

  /**
   * Renderiza todas las instancias del modal.
   */
  function renderRecentSearches() {
    const searches = getRecentSearches();

    document
      .querySelectorAll('[data-recent-searches-section]')
      .forEach((section) => {
        const container = section.querySelector(
          '[data-recent-searches]'
        );

        if (!container) {
          return;
        }

        container.innerHTML = '';

        if (searches.length === 0) {
          section.hidden = true;
          return;
        }

        searches.forEach((term) => {
          container.appendChild(createSearchLink(term, container));
        });

        section.hidden = false;
      });
  }

  /**
   * Detecta envíos de cualquier formulario de búsqueda.
   */
  function bindSearchForms() {
    document.querySelectorAll('form[role="search"]').forEach((form) => {
      if (form.dataset.recentSearchBound === 'true') {
        return;
      }

      form.dataset.recentSearchBound = 'true';

      form.addEventListener('submit', () => {
        const searchInput = form.querySelector('input[name="q"]');

        if (searchInput) {
          saveRecentSearch(searchInput.value);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    /*
     * También guarda el término cuando el usuario llega
     * directamente a la página /search.
     */
    const currentUrl = new URL(window.location.href);
    const currentQuery = currentUrl.searchParams.get('q');

    if (
      currentUrl.pathname.replace(/\/+$/, '').endsWith('/search') &&
      currentQuery
    ) {
      saveRecentSearch(currentQuery);
    }

    bindSearchForms();
    renderRecentSearches();
  });

  /*
   * Sincroniza las búsquedas entre pestañas del mismo navegador.
   */
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) {
      renderRecentSearches();
    }
  });
})();